"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
var _projectLevel = require("@/utils/projectLevel");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    courseTwo: _courseTwo.default
  },
  data: function data() {
    return {
      menusName: '',
      // imgBanner: require('../../../assets/img/banner3.png'),
      menusList: [{
        tit: '产业分类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '职业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wJob)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '级别',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(_projectLevel.projectLevelOptions)),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      query: {
        courseName: "",
        courseSource: "",
        pageNum: 1,
        pageSize: 20,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: '',
        schoolId: ''
      },
      list: [],
      total: 0,
      loading: false
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      console.log('dianji', e);
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log('dianji', e);
      if (e[0] == '产业分类') {
        if (e[1].name == '全部') {
          this.query.industry = '';
        } else {
          this.query.industry = e[1].name;
        }
      } else if (e[0] == '行业门类') {
        this.query.industryDetail = e[1].remark;
      } else if (e[0] == '职业门类') {
        if (e[1].name == '全部') {
          this.query.occupationCategory = '';
        } else {
          this.query.occupationCategory = e[1].name;
        }
      } else if (e[0] == '级别') {
        if (e[1].name == '全部') {
          this.query.courseLevel = '';
        } else {
          this.query.courseLevel = e[1].name;
        }
      }
      this.query.pageNum = 1;
      this.getList();
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 1;
              return (0, _index2.getReceptionList)(_objectSpread(_objectSpread({}, this.query), {}, {
                showStatus: 1
              }));
            case 1:
              res = _context.sent;
              if (res.code == 200) {
                this.list = res.rows;
                this.total = res.total;
                this.loading = false;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _ref, _ref$occupationCatego, occupationCategory, _ref$courseType, courseType, _ref$majorName, majorName;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // 从URL中获取occupationCategory参数
            _ref = this.$route.query || {}, _ref$occupationCatego = _ref.occupationCategory, occupationCategory = _ref$occupationCatego === void 0 ? '' : _ref$occupationCatego, _ref$courseType = _ref.courseType, courseType = _ref$courseType === void 0 ? '' : _ref$courseType, _ref$majorName = _ref.majorName, majorName = _ref$majorName === void 0 ? '' : _ref$majorName;
            if (occupationCategory) {
              this.query.occupationCategory = occupationCategory;
              this.menusName = occupationCategory;
            }
            if (courseType) {
              this.query.courseType = courseType;
            }
            if (majorName) {
              this.query.majorName = majorName;
            }
            _context2.next = 1;
            return this.getList();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};